/* Name: handleFileSASToken.tsx
* Copyright: (c) DA-Design Oy
* Creation date: 15.05.2024   (EKn)
*
* Description: 
*/

import { sm4request } from './tokenInterceptor';

// Used only for local development
const API_SERVER = import.meta.env.VITE_API_SERVER as string;
const containerName = `m-sm4-filemanager-updates-blob-container`;

interface SasResponse {
    url: string;
  };

export async function handleFileSasToken(file: File) {
    const permission = 'w'; //write
    const timerange = 500; //minutes
    //let data: SasResponse = {url: "",};

    if (!file) return;

    return sm4request.post<SasResponse>(
      `/api/sas?file=${encodeURIComponent(file.name)}&permission=${permission}&container=${containerName}&timerange=${timerange}`,
    );
}
